import { MultiSelect } from 'primereact/multiselect';
import { useEffect, useState } from 'react';

import { useEmployee } from '../context/employee';

function EmployeeMultiSelect({ onChange, addCurrent, employees }) {
    const { employee, employees: _employees } = useEmployee();

    const [loaded, setLoaded] = useState(false);
    const [employeesLoaded, setEmployeesLoaded] = useState(false);
    const [displayedEmployees, setDisplayedEmployees] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState([]);

    const employeeOptionTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div className={!option.active ? 'text-red-500' : ''}>{option.name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    useEffect(() => {
        if (selectedEmployees) {
            onChange(selectedEmployees);
        }
    }, [selectedEmployees, onChange]);

    useEffect(() => {
        if (!!addCurrent && !loaded && employee._id) {
            setSelectedEmployees((prev) => {
                if (Array.isArray(prev)) {
                    return [...prev, _employees.find((e) => e._id === employee._id)];
                }

                return [employee];
            });
            setLoaded(true);
        }
    }, [addCurrent, employee, _employees, loaded]);

    useEffect(() => {
        if (!addCurrent) {
            setDisplayedEmployees([..._employees].sort((a, b) => (a.name > b.name ? 1 : -1)));
        }

        if (!!addCurrent) {
            setDisplayedEmployees(
                [..._employees].filter((e) => e.active).sort((a, b) => (a.name > b.name ? 1 : -1))
            );
        }
    }, [addCurrent, _employees]);

    useEffect(() => {
        if (!employeesLoaded && Array.isArray(employees)) {
            setSelectedEmployees([...employees]);
            setEmployeesLoaded(true);
        }
    }, [employees, employeesLoaded]);

    return (
        <MultiSelect
            dataKey="_id"
            display="chip"
            className="w-full md:w-30rem"
            value={selectedEmployees}
            onChange={(e) => setSelectedEmployees(e.value)}
            options={displayedEmployees}
            optionLabel="name"
            placeholder="Select Employees"
            itemTemplate={employeeOptionTemplate}
        />
    );
}

export default EmployeeMultiSelect;
